import { FormFieldWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import ShopProduct from './ShopProduct.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.String,
    widget: 'ShopProduct',
    multi: false
  })
)
export class FormStringShopProductFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(ShopProduct);
    return this;
  }

  @Widget.Reactive()
  get _dataSource() {
    return this.formData.tradeOrderDetails || [];
  }

  @Widget.Reactive()
  get rModel() {
    return this.model;
  }

  @Widget.Reactive()
  _formData: any;

  @Widget.Watch('formData', { immediate: true, deep: true })
  watchFormData(val) {
    this._formData = val;
  }
}
